export default "__VITE_ASSET__DxYRvIK7__"